'use client';

import type { ReactElement } from 'react';
import { FacebookIcon } from '@/shared/components/primitives/svg/facebook-icon';
import { AccountProvider } from '@ecom/storefront-auth-db';
import { signInWithFacebook } from '@/features/auth/internal/actions/social-auth-actions';
import { SocialAuthButton } from '@/features/auth/shared/components/social-auth-button';
import { cn } from '@ecom/helper-react-class-combine';

type FacebookLinkProps = {
  buttonText: string;
  intent: 'login' | 'signup';
  callbackUrl?: string;
  returnTo?: string;
  className?: string;
  buttonClassName?: string;
  onStart?: () => void;
  subscribeToNewsletter?: boolean;
  onInClientSuccess?: () => void;
};

export const FacebookLink = ({
  buttonText,
  intent,
  callbackUrl,
  returnTo,
  className,
  buttonClassName,
  onStart,
  subscribeToNewsletter,
  onInClientSuccess,
}: FacebookLinkProps): ReactElement => {
  return (
    <SocialAuthButton
      buttonText={buttonText}
      intent={intent}
      provider={AccountProvider.FACEBOOK}
      icon={<FacebookIcon />}
      callbackUrl={callbackUrl}
      returnTo={returnTo}
      className={cn('mb-2', className)}
      buttonClassName={cn(
        'h-full w-full min-w-64 bg-blue-600 text-white hover:bg-blue-500 hover:!text-white disabled:cursor-not-allowed disabled:opacity-70 lg:hover:!text-white',
        buttonClassName,
      )}
      onStart={onStart}
      onWebSignIn={signInWithFacebook}
      subscribeToNewsletter={subscribeToNewsletter}
      onInClientSuccess={onInClientSuccess}
    />
  );
};
